import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Predictive Analytics",
        description: "Leverage advanced AI models to predict future outcomes, helping you make proactive decisions.",
        imgUrl: "./img/services/ai-insights/predictive-analytics.jpg",
    },
    {
        title: "Customer Insights",
        description: "Gain deeper understanding of customer behavior and preferences to tailor marketing strategies.",
        imgUrl: "./img/services/ai-insights/customer-insights.jpg",
    },
    {
        title: "Sales Forecasting",
        description: "Use AI to analyze trends and forecast sales, optimizing resource allocation and sales strategies.",
        imgUrl: "./img/services/ai-insights/sales-forecasting.jpg",
    },
    {
        title: "Automated Decision-Making",
        description: "Enable AI to automate routine decisions and actions, improving operational efficiency.",
        imgUrl: "./img/services/ai-insights/auto-decision-making.jpg",
    },
    {
        title: "AI-Powered Automation",
        description: "Automate business processes and tasks with AI, reducing manual work and increasing productivity.",
        imgUrl: "./img/services/ai-insights/ai-power.jpg",
    },
    {
        title: "Real-Time Insights",
        description: "Gain real-time business intelligence to make data-driven decisions on the fly.",
        imgUrl: "./img/services/ai-insights/realtime-insights.jpg",
    },
];

const AIInsights = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "AI Insights", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="AI Insights Solutions" description="Unlock the power of artificial intelligence with Dynamics 365 AI Insights, providing actionable insights to drive smarter decisions across your organization." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What are Dynamics 365 AI Insights?</h2>
                            <p>
                                Dynamics 365 AI Insights leverages advanced artificial intelligence and machine learning algorithms to provide real-time, predictive, and actionable insights. These insights help organizations make better decisions, optimize operations, and improve customer experiences. By incorporating AI into business processes, Dynamics 365 enables smarter decision-making at every level of your organization.
                            </p>
                            <img
                                src="./img/services/ai-insights.jpg"
                                alt="AI Insights Solutions"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Key Features of AI Insights</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Using Dynamics 365 AI Insights</h2>
                            <ul>
                                <li>
                                    <strong>Improved Decision Making:</strong> Make data-driven decisions with AI-generated insights and predictive models.
                                </li>
                                <li>
                                    <strong>Enhanced Customer Experience:</strong> Understand customer needs and behaviors to create more personalized experiences.
                                </li>
                                <li>
                                    <strong>Increased Operational Efficiency:</strong> Automate processes and identify inefficiencies to streamline operations.
                                </li>
                                <li>
                                    <strong>Sales Optimization:</strong> Forecast sales trends and optimize resource allocation to meet business goals.
                                </li>
                                <li>
                                    <strong>Real-Time Intelligence:</strong> Access real-time insights to respond quickly to market changes and make informed decisions.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Unlock the Power of AI in Your Organization</h2>
                            <p>
                                Harness the capabilities of AI with Dynamics 365 AI Insights to drive smarter business decisions. <br />
                                Reach out to us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default AIInsights;
